// Load the full drawing explorer only when its app block approaches the viewport.
(() => {
  let loading;
  const load = root => {
    if (loading) return;
    loading = document.createElement('script');
    loading.src = root.dataset.finderScript;
    loading.defer = true;
    loading.onerror = () => { root.textContent = 'The parts finder could not load. Please refresh this page.'; };
    document.head.append(loading);
  };
  const roots = document.querySelectorAll('[data-ccm-parts-finder][data-finder-script]');
  if (!('IntersectionObserver' in window)) { roots.forEach(load); return; }
  const observer = new IntersectionObserver(entries => {
    entries.filter(entry => entry.isIntersecting).forEach(entry => { load(entry.target); observer.unobserve(entry.target); });
  }, {rootMargin:'300px'});
  roots.forEach(root => observer.observe(root));
})();
